import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Customer } from '../app.types';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomerManagementService } from '../services/customer-management/customer-management.service';
import { isFormValid } from '../core/form-helpers';
import { ModalComponent } from '../core/modal/modal.component';
import { Subject } from 'rxjs';

@Component({
    selector: 'customer-form-modal',
    templateUrl: './customer-form-modal.component.html',
    styleUrls: ['./customer-form-modal.component.scss'],
    standalone: false
})
export class CustomerFormModalComponent implements OnInit {
  @Input() customer: Customer;
  @Input() triggerRefresh: Subject<null>;
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  @ViewChild(ModalComponent) modal: ModalComponent;

  form: FormGroup;
  requestInProgress = false;

  readonly nameErrors = { required: 'Please enter a customer name' };
  readonly cloudInstanceUrlErrors = { required: 'Please enter a customer instance url' };
  readonly subdomainErrors = { required: 'Please enter a subdomain' };
  readonly tenantIdErrors = { required: 'Please enter a Tenant Id' };

  /**
   * CTOR
   */
  constructor(private formBuilder: FormBuilder, private customerManagementService: CustomerManagementService) {
    this.form = formBuilder.group({
      name: ['', Validators.required],
      cloudInstanceUrl: ['', Validators.required],
      subdomain: ['', Validators.required],
        tenantId: ['', Validators.required],
      enabled: [false],
    });
  }

  /**
   * On Init
   */
  ngOnInit() {
    if (this.customer != null)
    {
        console.log("customer JSON: " + JSON.stringify(this.customer));
        this.form.setValue({
            name: this.customer.name,
            cloudInstanceUrl: this.customer.cloudInstanceUrl,
            subdomain: this.customer.subdomain,
            enabled: this.customer.enabled,
            tenantId: this.customer.tenantId
        });
    }
    else
    {
        console.log("No Customer")
    }

  }

  submitForm() {
    if (!isFormValid(this.form)) {return;}

    const formData = this.form.getRawValue();
    this.requestInProgress = true;
    // ADD
    if (this.customer == null) {
      this.customerManagementService.addCustomer(formData).subscribe((res) => {
        if (res != null) {
          this.triggerRefresh.next(null);
          this.modal.closeModal();
        }
      });
    }
    // EDIT
    else {
      this.customerManagementService.editCustomer({ ...formData, id: this.customer.id }).subscribe((res) => {
        if (res != null) {
          this.triggerRefresh.next(null);
          this.modal.closeModal();
        }
      });
    }
  }

  /**
   * Deletes a customer
   */
  deleteCustomer() {
    if (this.customer) {
      this.customerManagementService.deleteCustomer(this.customer).subscribe((res) => {
        if (res != null) {
          this.triggerRefresh.next(null);
          this.modal.closeModal();
        }
      });
    }
  }

  /**
   * Modal Cleanup
   */
  modalCleanup() {
    // if a request was triggered, emit true to trigger a refresh of customer table
    this.close.emit(this.requestInProgress);
    this.requestInProgress = false;
  }
}
